import React from 'react';
import { Check, ShieldCheck, Smartphone } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Offer() {
  const features = ['6 módulos completos', '6 bonos incluidos', 'Formato PDF digital', 'Acceso desde celular o computadora'];
  return <section id="oferta" className="py-24 bg-cream-200" data-id="element-132">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <FadeIn className="bg-white rounded-[3rem] p-8 md:p-16 shadow-soft-lg border border-brand-50 text-center relative overflow-hidden" data-id="element-134">
          {/* Decorative blobs */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-brand-50 rounded-full blur-3xl -ml-32 -mt-32 opacity-50" data-id="element-135"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-cream-300 rounded-full blur-3xl -mr-32 -mb-32 opacity-50" data-id="element-136"></div>

          <div className="relative z-10" data-id="element-137">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-100 text-red-700 text-sm font-bold mb-8 animate-pulse" data-id="element-138">
              <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-139"></span>
              OFERTA DISPONIBLE HOY
            </div>

            <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-950 mb-6" data-id="element-140">
              Acceso inmediato al sistema completo
            </h2>

            <div className="flex flex-col items-center gap-4 mb-10" data-id="element-141">
              {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3 text-brand-800 font-medium text-lg" data-id="element-142">
                  <Check className="w-6 h-6 text-brand-500" data-id="element-143" />
                  <span data-id="element-144">{feature}</span>
                </div>)}
            </div>

            {/* Price card */}
            <div className="inline-flex flex-col items-center bg-brand-50 border-2 border-brand-200 rounded-3xl px-8 py-6 mb-8 relative" data-id="element-145">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-brand-600 text-white text-xs font-bold tracking-wider whitespace-nowrap" data-id="element-146">
                PRECIO ESPECIAL
              </div>
              <p className="text-sm text-brand-600 font-medium mb-1" data-id="element-147">
                Pago único · Acceso de por vida
              </p>
              <div className="flex items-baseline gap-2" data-id="element-148">
                <span className="text-2xl text-brand-500 line-through opacity-60 font-medium" data-id="element-149">
                  $39.990
                </span>
                <span className="text-5xl md:text-6xl font-serif font-bold text-brand-950" data-id="element-150">
                  $19.990
                </span>
              </div>
              <p className="text-xs text-brand-600 font-semibold mt-2" data-id="element-151">
                Ahorrás más del 50% hoy
              </p>
            </div>

            <a href="https://checkout.equilibriodigital.shop/cart/47582420140222:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto px-10 py-5 bg-brand-600 hover:bg-brand-700 text-white rounded-2xl font-bold text-xl transition-all transform hover:scale-[1.02] hover:shadow-soft-lg shadow-soft mb-6" data-id="element-152">
              QUIERO MEJORAR MI ALIMENTACIÓN HOY
            </a>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-brand-600 font-medium" data-id="element-153">
              <div className="flex items-center gap-2" data-id="element-154">
                <ShieldCheck className="w-5 h-5" data-id="element-155" />
                <span data-id="element-156">Pago seguro Mercado Pago</span>
              </div>
              <div className="hidden sm:block w-1 h-1 rounded-full bg-brand-300" data-id="element-157"></div>
              <div className="flex items-center gap-2" data-id="element-158">
                <Smartphone className="w-5 h-5" data-id="element-159" />
                <span data-id="element-160">Acceso inmediato</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}